import { useValidateOrderStatus } from '@contexts/ValidateOrderStatus/useValidateOrderStatus'
import * as React from 'react'

import { createContext } from '~logic/lib/react'
import {
  PaymentLockedOrderProvider as SharedPaymentLockedOrderProvider,
  usePaymentLockedOrderCtx,
} from '~shared/segments/PaymentLockedScreen'

type TGatewayUrls = ReturnType<typeof useValidateOrderStatus>['gatewayUrls']

const [
  GatewayUrlsProvider, //
  useGatewayUrlsCtx,
] = createContext<TGatewayUrls>(`GatewayUrls`)

type TProps = RequiredChildren & {
  orderId: ID
}

/**
 * Context provider of the PaymentLockedScreen:
 * - use `usePaymentLockedOrder` to obtain the order with the branch phone,
 * - use `useGatewayUrls` to get payment gateway urls associated with the payment in process.
 *
 * ! Context values can be `null`.
 */
export const PaymentLockedOrderProvider: React.FC<TProps> = ({ children, orderId }) => {
  // validate screen route & return gateway urls
  const { gatewayUrls } = useValidateOrderStatus()

  return (
    <SharedPaymentLockedOrderProvider orderId={orderId}>
      <GatewayUrlsProvider value={gatewayUrls}>{children}</GatewayUrlsProvider>
    </SharedPaymentLockedOrderProvider>
  )
}

export { usePaymentLockedOrderCtx, useGatewayUrlsCtx }
